import styled, { css } from 'styled-components'

export const Wrapper = styled.span`
  .label-white {
    font-weight: lighter !important;
    padding: 3px 6px;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-size: var(--smallFont);
    min-width: auto;
  }
  .label-gray {
    font-weight: normal;
    padding: 3px 6px;
    border-radius: 6px;
    border: 1px solid #b3b3b3;
    font-size: var(--smallFont);
    min-width: auto;
    background-color: #f2f2f2;
    color: #666666;
    white-space: nowrap;
  }
`
